import { iRequest } from '../../utils/requestutil';

export async function queryConfig(payload) {
  return iRequest(
    `/iwms-openapi/api/processSchemeIgnoreConfig/queryConfig?interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'GET',
    },
  );
}

export async function queryField(payload) {
  return iRequest(
    `/iwms-openapi/api/processSchemeIgnoreConfig/queryField?interfaceName=${payload.interfaceName}`,
    {
      method: 'GET',
    },
  );
}

export async function save(payload) {
  return iRequest(
    `/iwms-openapi/api/processSchemeIgnoreConfig?companyUuid=${payload.companyUuid}&interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'POST',
      body: payload.fields,
    },
  );
}
